<template>
  <div class="level">
    <LevelRow
      :rowTooltip="rowTooltip"
      :hasAccess="hasAccess"
      :hideAction="labNotAvailable"
      contentType="lab"
      :contentId="content.id"
      :labType="contentType"
      :status="contentStatus"
      :parentStatus="parentStatus"
      :title="title"
      :learningArea="learningArea"
      :plansLink="plansLink"
      :isWatching="false"
      :details="labDetails"
      :disabled="isDisabled"
      :textClass="textClass"
      :progress="progress"
      @toggle="openLab"
      @click.native="openLab"
    >
    </LevelRow>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'LabLevel',
  components: {
    LevelRow,
  },
  props: {
    parentId: {
      type: String,
      required: true,
    },
    parentStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    contentStatus: {
      type: String,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      focusedLabId: state => state.labs.focusedLabId,
      runningLabSession: state => state.labs.runningLabSession,
      availablePasses: state => state.auth.available_passes,
    }),
    ...mapGetters({
      isOnTrialSubscription: 'subscriptions/isOnTrialSubscription',
      isCourtesyTrialUser: 'subscriptions/isCourtesyTrialUser',
      isSkillDiveB2BUser: 'auth/isSkillDiveB2BUser',
    }),
    isDisabled() {
      if (
        this.content.is_lab_experience &&
        !this.isSkillDiveB2BUser &&
        this.$route.name === 'playlists'
      )
        return true

      return false
    },
    rowTooltip() {
      if (this.isDisabled)
        return `<div>
            <p>
              <strong>Skill Dive License Required.</strong>
              <br />
              To access this lab, please get in touch with your account owner
              for acquiring the necessary license.
            </p>
          </div>`
      else return null
    },
    isLabFinished() {
      return (
        this.contentStatus &&
        this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
      )
    },
    learningArea() {
      return this.content.learning_areas?.[0]?.name
    },
    labNotAvailable() {
      return (
        (this.isOnTrialSubscription &&
          this.content.is_web_access &&
          !this.isCourtesyTrialUser) ||
        this.isDisabled
      )
    },
    labDetails() {
      let status = null
      status =
        this.runningLabSession?.lab_id === this.content.id
          ? 'Lab running'
          : status
      status =
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STOPPED
          ? 'Lab stopped'
          : status
      status = this.labNotAvailable
        ? 'This lab is not available during the trial period. <a class="level__title__label-detail-link" href="mailto:support@ine.com">Contact INE</a> to start your paid subscription now.'
        : status
      status = this.isDisabled ? 'Skill Dive' : status
      return status ? [status] : null
    },
    textClass() {
      if (this.labNotAvailable) {
        return 'warning'
      }
      if (
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STARTED
      )
        return 'green'
      if (
        this.content.session?.status === CONSTANTS.LABS.SESSION_STATUS.STOPPED
      )
        return 'red'
      return ''
    },
    progress() {
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED) {
        return 50
      }
      if (this.contentStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED) {
        return 100
      }
      return 0
    },
  },
  methods: {
    async openLab() {
      if (!this.labNotAvailable && this.hasAccess) {
        this.$emit('toggle-content', CONSTANTS.CONTENT_TYPES.LAB)
        const route = `${this.$route.name}-lab`
        const params = { labId: this.$props.content.id }
        params.id = this.parentId
        this.$router.push({
          name: route,
          params,
        })
      }
    },
  },
}
</script>
